import { Component, OnInit } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { State } from '@ngrx/store';
import { AppState, PatientCartActionTypes } from '@app/core/ngrx';
import { select, Store } from '@ngrx/store';
import { PrintPdfModel, TableBody } from '@app/core/models/print-pdf.model';
import { ImageService } from '@app/core/services';
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;
import { CartPrintService } from '@app/core/services';

@Component({
  selector: 'ecp-patient-cart-print',
  templateUrl: './patient-cart-print.component.html',
  styleUrls: ['./patient-cart-print.component.scss'],
})
export class PatientCartPrintComponent implements OnInit {
  public cart$: Observable<any>;
  processedImage$: any;
  totalFrames$: any;

  processedImage: any;
  totalFrames: any;

  constructor(
    private store: Store<AppState>,
    private state: State<AppState>,
    private cartPrintService: CartPrintService,
  ) {}

  ngOnInit(): void {
    this.cart$ = this.store.pipe(select(state => state.patientCart.cart));

    this.processedImage$ = this.store.pipe(
      select(state => state.patientCart.printState.processedImage),
    );
    this.processedImage$.subscribe(processImage => {
      this.processedImage = processImage;
    });

    this.totalFrames$ = this.store.pipe(
      select(state => state.patientCart.printState.totalFrames),
    );
    this.totalFrames$.subscribe(totalFrames => {
      this.totalFrames = totalFrames;
    });
  }

  printCart() {
    this.processedImage = this.cartPrintService.processedImage;
    this.totalFrames = this.cartPrintService.totalFrames;
    let user = this.state.getValue().user.profile;
    let cart = this.state.getValue().patientCart.cart;
    cart = JSON.parse(JSON.stringify(cart));
    this.cartPrintService.printCart(cart, user);
  }
}
